import React, {useEffect} from 'react'
import {compose} from 'redux'
import {connect} from 'react-redux'
import {formValueSelector} from 'redux-form'
import PropTypes from 'prop-types'
import {change} from 'redux-form'
import {resolve} from '@cred/shared/utils'
import {Radio, Dropdown} from '../components'
import ControlForm from '../components/control-form'
import withForm from '@cred/shared/hoc/with-form'

/**
 * Renders a set of radios and a dropdown containing the remaining options.
 * @visibleName Radio Select
 */
const controlFormSelector = /*#__PURE__*/ formValueSelector('control-form'),
  mapStateToProps = (state, {formName, name}) => ({
    controlRadioValue: controlFormSelector(state, `${formName}.${name}-radio`),
    controlDropdownValue: controlFormSelector(state, `${formName}.${name}-dropdown`)
  }),
  /**
   * @deprecated RadioSelect is deprecated, please use @cred/react-radio-dropdown-field or @cred/react-radio-dropdown-field/[reduxForm|hookForm] instead.
   */
  RadioSelect = props => {
    const {
        name,
        className,
        radioOptions,
        dropdownOptions,
        radioClassName,
        dropdownClassName,
        dropdownPlaceholder,
        dropdownLabel,
        onChange,
        formData,
        formName,
        dispatch,
        appearance,
        analyticsContexts
      } = props,
      radioName = `${formName}.${name}-radio`,
      dropdownName = `${formName}.${name}-dropdown`,
      onRadioChange = (event, value) => {
        dispatch(change('control-form', dropdownName, ''))
        dispatch(change(formName, name, value))
        onChange(event, value)
      },
      onDropdownChange = (event, value) => {
        dispatch(change('control-form', radioName, ''))
        dispatch(change(formName, name, value))
        onChange(event, value)
      },
      initialValue = resolve(`initial.${name}`, formData)

    useEffect(() => {
      const value = resolve(`values.${name}`, formData) || initialValue

      if (radioOptions.find(obj => obj.value === value)) {
        dispatch(change('control-form', radioName, value))
      } else if (dropdownOptions.find(obj => obj.value === value)) {
        dispatch(change('control-form', dropdownName, value))
      }
    }, [initialValue])

    return (
      <div className={className}>
        <ControlForm>
          {radioOptions.map(({label, value}) =>
            <Radio
              onChange={onRadioChange}
              key={value}
              name={radioName}
              className={radioClassName}
              withBorder={true}
              value={value}
              label={label}
              appearance={appearance}
              analyticsContexts={analyticsContexts}
            />
          )}
          <Dropdown
            onChange={onDropdownChange}
            label={dropdownLabel}
            placeholder={dropdownPlaceholder}
            name={dropdownName}
            options={dropdownOptions}
            className={dropdownClassName}
            icon={false}
            analyticsContexts={analyticsContexts}
          />
        </ControlForm>
      </div>
    )
  }

RadioSelect.propTypes = {

  /** Radio select name. It will be used by redux. */
  name: PropTypes.string.isRequired,

  /** Options to be rendered as radios. */
  radioOptions: PropTypes.array.isRequired,

  /** Options to be rendered inside the dropdown. */
  dropdownOptions: PropTypes.array.isRequired,

  /** Dropdown placeholder. */
  dropdownPlaceholder: PropTypes.string.isRequired,

  /** Redux-form state object **/
  formData: PropTypes.object,

  /** Class to be applied to the entire Radio select. */
  className: PropTypes.string,

  /** Class to be applied only to the radios. */
  radioClassName: PropTypes.string,

  /** Class to be applied only to the dropdown. */
  dropdownClassName: PropTypes.string,

  /** Label loocated inside the dropdown. */
  dropdownLabel: PropTypes.string,

  /** Function called when the radio select value is updated. */
  onChange: PropTypes.func,

  /** Form name to be used to dispatch actions */
  formName: PropTypes.string.isRequired,
  appearance: PropTypes.string,
  analyticsContexts: PropTypes.array
}

RadioSelect.defaultProps = {
  onChange: () => {},
  appearance: null,
  analyticsContexts: []
}

export {RadioSelect as RadioSelectNoHoc}

export default /*#__PURE__*/ compose(
  withForm,
  connect(mapStateToProps)
)(RadioSelect)
